import { useQuery } from "@tanstack/react-query";
import { clubApi } from "../../../club-api-client";

export function useDirectoryClubs(q: string, opts?: { enabled?: boolean; limit?: number }) {
	const limit = opts?.limit ?? 8;
	return useQuery({
		enabled: (opts?.enabled ?? true) && q.trim().length >= 2,
		placeholderData: (prev) => prev,
		queryFn: () => clubApi.directory.searchClubs({ limit, q }),
		queryKey: ["directory", "clubs", q, limit] as const,
	});
}
